import React from 'react';

import { HELP_EMAIL } from '@core/config';

export const HelpLink: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = (props) => (
  <a {...props} href={`mailto:${HELP_EMAIL}`}>
    {HELP_EMAIL}
  </a>
);
